import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function UploadPlan() {
  const navigate = useNavigate();
  const [projectName, setProjectName] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dragOver, setDragOver] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const dropped = e.dataTransfer.files[0];
    if (dropped) setFile(dropped);
  };

  const handleAnalyze = async () => {
    if (!file || !projectName) return alert('Please enter a project name and upload a plan.');
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('plan', file);
      const res = await axios.post('/api/analyze', formData);
      navigate('/form', { state: { extractedData: res.data.extractedData, projectName, fileName: file.name } });
    } catch (err) {
      alert('Error analyzing plan. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '680px', margin: '0 auto' }}>
      <div className="page-header">
        <div className="breadcrumb"><a href="/">Home</a> / <strong>New Project</strong></div>
        <h1 className="page-title">Upload Plan</h1>
        <p className="page-subtitle">Upload the approved engineering plan for this project</p>
      </div>

      <div className="card">
        <div className="form-group">
          <label className="form-label">Project Name</label>
          <input
            className="form-input"
            placeholder="Ex: Smith Residence — Wesley Chapel"
            value={projectName}
            onChange={e => setProjectName(e.target.value)}
          />
        </div>

        <div
          onDrop={handleDrop}
          onDragOver={e => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          style={{
            border: `2px dashed ${dragOver ? '#1a73e8' : '#e0e0e0'}`,
            borderRadius: '8px',
            padding: '48px',
            textAlign: 'center',
            backgroundColor: dragOver ? '#e8f0fe' : '#fafafa',
            cursor: 'pointer'
          }}
          onClick={() => document.getElementById('fileInput').click()}
        >
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>📄</div>
          <div style={{ fontWeight: '500', marginBottom: '6px' }}>Drag and drop your plan here</div>
          <div style={{ fontSize: '13px', color: '#666', marginBottom: '16px' }}>Supports PDF and image files (JPG, PNG)</div>
          <button className="btn-secondary" onClick={e => { e.stopPropagation(); document.getElementById('fileInput').click(); }}>
            Browse files
          </button>
          <input id="fileInput" type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: 'none' }} onChange={e => setFile(e.target.files[0])} />
        </div>

        {file && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', border: '1px solid #e0e0e0', borderRadius: '6px', marginTop: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '24px' }}>📄</span>
              <div>
                <div style={{ fontWeight: '500', fontSize: '14px' }}>{file.name}</div>
                <div style={{ fontSize: '12px', color: '#666' }}>{(file.size / 1024 / 1024).toFixed(2)} MB</div>
              </div>
            </div>
            <button onClick={() => setFile(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: '#666' }}>✕</button>
          </div>
        )}
      </div>

      <div className="action-buttons">
        <button className="btn-secondary" onClick={() => navigate('/')}>Cancel</button>
        <button className="btn-primary" onClick={handleAnalyze} disabled={loading}>
          {loading ? 'Analyzing...' : 'Analyze Plan →'}
        </button>
      </div>
    </div>
  );
}

export default UploadPlan;